import api, { CustomAxiosRequestConfig } from './api-backend';
import { AuthResponse, LoginRequest } from 'types/api';

/**
 * Auth service for authentication related API calls
 */
const authService = {
  /**
   * Log in a user
   * @param {LoginRequest} credentials - User login credentials
   * @returns {Promise<AuthResponse>} Login response with token and user data
   */
  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    const response = await api.post('/v1/auth/login', credentials, {
      _isLoginRequest: true,
    } as CustomAxiosRequestConfig);
    return response.data;
  },

  /**
   * Log out the current user
   * @returns {Promise<void>}
   */
  logout: async (): Promise<void> => {
    try {
      // Call logout endpoint if backend requires it
      await api.post('/v1/auth/logout');
    } catch {
      // Silent failure - just continue to clear local storage
    } finally {
      // Always clear local storage regardless of API success
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
    }
  },

  /**
   * Check if user is currently authenticated
   * @returns {boolean}
   */
  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('auth_token');
  },
};

export default authService;
